import { render, staticRenderFns } from "./rcc-header-sorter.vue?vue&type=template&id=9c01471a&scoped=true&"
import script from "./rcc-header-sorter.vue?vue&type=script&lang=js&"
export * from "./rcc-header-sorter.vue?vue&type=script&lang=js&"
import style0 from "./rcc-header-sorter.vue?vue&type=style&index=0&id=9c01471a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c01471a",
  null
  
)

export default component.exports